import { defineMessages } from 'react-intl'

const scope =
  'procurify.platform.banking.features.create-beneficiary.views.CreateBeneficiaryForm'

export default defineMessages({
  addPaymentMethodButtonLabel: {
    id: `${scope}.addPaymentMethodButtonLabel`,
    defaultMessage: 'Add payment method',
  },
  backButtonLabel: {
    id: `${scope}.backButtonLabel`,
    defaultMessage: 'Back',
  },
})
